import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.trouble-ticket-mandant-options';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationTroubleTicketMandantOptionsEffects {

    TroubleTicketMandantOptions$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_TROUBLE_TICKET_MANDANT_OPTIONS),
        mergeMap((x: ac.GetTroubleTicketMandantOptionsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getTroubleTicketMandantOptions().pipe(
                map((result: any) => {
                    return new ac.GetTroubleTicketMandantOptionsErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetTroubleTicketMandantOptionsFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.TroubleTicketQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.TroubleTicketQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.TroubleTicketQueryService);
        }
        return this.service;
    }
}
